import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  NgxGalleryOptions,
  NgxGalleryImage,
  NgxGalleryAnimation
} from "ngx-gallery";
import { MediaServiceService } from "../media-service.service";

import { configureImageArr } from "./utils";

@Component({
  selector: "app-photo-gallery",
  templateUrl: "./photo-gallery.component.html",
  styleUrls: ["./photo-gallery.component.css"]
})
export class PhotoGalleryComponent implements OnInit {
  constructor(
    private activated: ActivatedRoute,
    private mD: MediaServiceService
  ) {}
  id: string;
  year: string;
  raceDate: object;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  raceImages: any[];
  currentDetails: any;

  ngOnInit() {
    this.activated.params.subscribe(result => {
      this.id = result["id"];
      this.year = result["year"];
    });

    this.mD
      .getCircuitDetails(this.id)
      .valueChanges()
      .subscribe(circuitDetails => {
        this.currentDetails = circuitDetails;
      });

    this.mD
      .getRaceDate(this.id, this.year)
      .valueChanges()
      .subscribe(raceDate => {
        this.raceDate = raceDate;
      });

    this.mD
      .getImagesYear(this.id, this.year)
      .valueChanges()
      .subscribe(x => {
        const result = configureImageArr(x);
        this.galleryImages = result;
      });

    this.galleryOptions = [
      {
        width: "600px",
        height: "400px",
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide
      },
      {
        breakpoint: 800,
        width: "100%",
        height: "600px",
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      {
        breakpoint: 400,
        preview: false
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/media/photo-gallery/photo-gallery.component.ts